<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs2>
          <div class="form-control">
            <label>Start date</label>
            <DatepickerCustomDialog @input="onChangeDate" v-model="selectedDate.start">
              <input readonly :value="getDateFormated(selectedDate.start)" type="text" />
            </DatepickerCustomDialog></div
        ></v-flex>
        <v-flex xs2 class="ml-2">
          <div class="form-control">
            <label>End date</label>
            <DatepickerCustomDialog @input="onChangeDate" v-model="selectedDate.end">
              <input readonly :value="getDateFormated(selectedDate.end)" type="text" />
            </DatepickerCustomDialog></div
        ></v-flex>
      </v-layout>
      <div>
        <v-layout row wrap>
          <v-flex xs7 class="mb-4">
            <div class="primary--text mb-2" style="font-size: 22px">เลือกกลุ่ม</div>
            <multiselect
              :loading="pageloading"
              @input="onChangeGroup"
              placeholder="เลือกกลุ่ม"
              label="name"
              v-model="input.group"
              :show-labels="false"
              :options="groupOptions"
            ></multiselect>
          </v-flex>
          <v-flex xs7>
            <div class="primary--text mb-2" style="font-size: 22px">เลือก LINE OA</div>
            <multiselect
              :loading="pageloading"
              @input="onChangePage"
              placeholder="เลือก LINE OA"
              label="channelname"
              v-model="input.channels"
              :show-labels="false"
              :options="filteredChannel"
              :allow-empty="false"
            ></multiselect>
          </v-flex>
          <v-flex xs8>
            <div class="primary--text mb-2 mt-4" style="font-size: 22px">เลือกบรอดแคสต์</div>

            <multiselect
              @input="onChangeBroadcast"
              :loading="postloading"
              placeholder="เลือกบรอดแคสต์"
              label="title"
              v-model="input.post"
              :show-labels="false"
              :options="alltopic"
              :allow-empty="false"
            ></multiselect>
          </v-flex>
        </v-layout>
        <div v-if="postloading" class="text-xs-center mt-5">
          <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
        </div>
        <div v-else-if="input.channels || input.group || input.title" class="px-3">
          <v-divider class="mt-4"></v-divider>
          <div class="my-4" style="font-weight: bold; color: grey; font-size: 22px">
            จำนวนการเข้าถึง
          </div>
          <v-layout row wrap class="ma-0">
            <v-flex xs12 class="px-2">
              <v-card>
                <div class="px-4 pt-4 text-xs-center pb-0">
                  <span style="font-size: 33px; color: #00bf42">
                    {{ numberFormat(sumReach) }}
                  </span>
                </div>
                <div
                  class="pa-2 text-xs-center white--text"
                  style="background-color: #00bf42; font-size: 23px"
                >
                  <em class="fab fa-line pr-2" /> Reach
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import moment from 'moment'
import axios from 'axios'

export default {
  props: ['channels', 'pageloading', 'groupOptions'],
  components: {
    multiselect,
    DatepickerCustomDialog
  },
  data() {
    return {
      data: [],
      postdata: { name: '' },
      loading: false,
      postloading: false,
      showSelectPost: false,
      intentpostidlist: '',
      broadcast: [],
      selectedDate: {
        // start: '',
        // end: '',
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      input: {
        channels: '',
        post: '',
        group: '',
        title: ''
      },
      postdata: [],
      linetitle: []
    }
  },
  computed: {
    alltopic() {
      if (this.input.group || this.input.channels) {
        var tempdata = []
        return this.data.filter((el) => {
          if (tempdata.includes(el.title)) {
            return false
          } else {
            tempdata.push(el.title)
            return true
          }
        })
      } else return this.linetitle
    },
    sumReach() {
      var result = 0

      if (this.data && this.data.length) {
        var data = [...this.data]

        if (this.input.post) {
          data = data.filter((el) => el.title == this.input.post.title)
        }

        result = data.reduce((acc, cur) => {
          return acc + parseInt(cur.reach)
        }, 0)
      }
      return result
    },

    filteredChannel() {
      var result = this.channels.filter((el) => el.app == 'line')
      if (this.input.group) {
        result = result.filter((el) =>
          el.groupids ? el.groupids.includes(parseInt(this.input.group.id)) : false
        )
      }

      return result
    },
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getPowerbuyLineReachTitle()
  },
  methods: {
    onChangeBroadcast(val) {
      if (!this.input.channels && !this.input.group) {
        this.input.title = val.title
        this.getData()
      }
    },
    getPowerbuyLineReachTitle() {
      api.getPowerbuyLineReachTitle(
        {
          pageid: this.selectedBot.pageid,
          dateFrom: this.selectedDate.dateFrom,
          dateTo: this.selectedDate.dateTo
        },
        (err, response) => {
          this.linetitle = response.data
        }
      )
    },
    onChangeGroup() {
      this.getData()
      this.input.channels = ''
      this.input.post = ''
    },

    onChangeDate() {
      if (this.input.channels || this.input.group || this.input.title) {
        this.getData()
      }
    },
    // getBroadcast() {
    //   this.loading = true
    //   var data = {
    //     pageid: this.selectedBot.pageid,
    //   }
    //   api.getPowerbuyLineBroadcast(data, (err, response) => {
    //     this.loading = false
    //     this.broadcast = response.data
    //   })
    // },
    onChangePost() {},
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,
        channelId: this.input.channels.channelid
      }
      if (this.input.group.id && !this.input.channels) {
        Object.assign(data, { groupId: this.input.group.id })
      }
      if (this.selectedDate.start) {
        data.dateFrom = moment(this.selectedDate.start).format('YYYY-MM-DD')
      }
      if (this.selectedDate.end) {
        data.dateTo = moment(this.selectedDate.end).format('YYYY-MM-DD')
      }
      if (this.input.title) {
        Object.assign(data, { title: this.input.title })
      }
      this.postloading = true
      api.getPowerbuyLineReach(data, (err, response) => {
        this.postloading = false
        if (response.responsecode == 200) {
          this.data = response.data
        }
      })
    },
    onChangePage(val) {
      //   this.getPublishedPost(val.channelid)
      this.getData()
    },
    getDateFormated(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else return ''
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Analytics/ReachLine.vue